import React, { FC, ReactElement, useEffect } from 'react';
import { useSettings } from '../../../hooks/useSettings';
import {
  useAnalyticsPost,
  NarvarEventTypes,
  NarvarEventComponents,
} from '../../../hooks/Analytics';
import Divider from '../../ui/Divider/Divider';
import { BigHeader } from '../../ui/Header/Header';
import { useTheme } from '../../../hooks/useTheme';

export interface SectionDividerProps {
  sectionDividerId: string;
  featureName?: string;
}

// Note: This type should come directly from useSettings, but it's formal type is currently any.
type SectionDividers = Record<string, { title: string; divider: boolean }>;

const SectionDivider: FC<SectionDividerProps> = ({
  featureName,
  sectionDividerId,
}): ReactElement | null => {
  const { sectionDividers } = useSettings() as {
    sectionDividers: SectionDividers;
  };

  const { sectiondividerPrimaryNone } = useTheme();

  const logEvent = useAnalyticsPost();

  useEffect(
    () => {
      if (!(sectionDividers && sectionDividers[sectionDividerId])) return;

      logEvent({
        eventComponent: NarvarEventComponents.NTH_BLOCK_SECTION_DIVIDER,
        eventFeature: NarvarEventComponents.NTH_BLOCK_SECTION_DIVIDER,
        eventType: NarvarEventTypes.COMPONENT_RENDER,
        feature: featureName,
        eventId: sectionDividerId,
        pageComponent: NarvarEventComponents.NTH_BLOCK_SECTION_DIVIDER,
      });
    },
    // TODO: Make this dependency array exhaustive
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sectionDividers, sectionDividerId],
  );

  if (!(sectionDividers && sectionDividers[sectionDividerId])) return null;

  const { title, divider = false } = sectionDividers[sectionDividerId];

  return (
    <>
      <div
        style={{
          minHeight: '5rem',
          ...sectiondividerPrimaryNone,
        }}
        data-test="sectionDividerContainer"
      >
        {title && <BigHeader>{title}</BigHeader>}
      </div>
      {divider && <Divider />}
    </>
  );
};

export default SectionDivider;
